let folder = 'unternehmen/karriere'
export const state = () => ({
  meta: null,
  content: null,
  description: null,
  benefits: null,
  requirements: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  content(state) {
    return state.content
  },
  description(state) {
    return state.description
  },
  benefits(state) {
    return state.benefits
  },
  requirements(state) {
    return state.requirements
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setContent(state, { data }) {
    state.content = data
  },
  setDescription(state, { data }) {
    state.description = data
  },
  setBenefits(state, { data }) {
    state.benefits = data
  },
  setRequirements(state, { data }) {
    state.requirements = data
  }
}
export const actions = {
  getMeta({ commit, rootState }, { jobFolder }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/${jobFolder}/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContent({ commit, rootState }, { jobFolder }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/${jobFolder}/content.json`)
      .then((res) => {
        commit('setContent', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getDescription({ commit, rootState }, { jobFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${jobFolder}/description.json`
      )
      .then((res) => {
        commit('setDescription', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getBenefits({ commit, rootState }, { jobFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${jobFolder}/benefits.json`
      )
      .then((res) => {
        commit('setBenefits', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getRequirements({ commit, rootState }, { jobFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${jobFolder}/requirements.json`
      )
      .then((res) => {
        commit('setRequirements', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
